import { loop } from '@wordpress/icons';
import { store } from '@wordpress/interactivity';

type ServerState = {
	state: {};
};

const storeDef = {
	actions: {
		*initProjectPage() {
			const { Swiper } = yield import('swiper');
			const { Navigation } = yield import('swiper/modules');

			new Swiper('.pg-swiper', {
				modules: [Navigation],
				slidesPerView: 'auto',
				direction: 'horizontal',
				allowTouchMove: true,
				grabCursor: true,
				slidesperGroupAuto: 'true',
				loop: true,
				loopFillGroupWithBlank: true,
				loopAdditionalSlides: 1,
				navigation: {
					enabled: true,
					nextEl: '.pg-button-next',
					prevEl: '.pg-button-prev',
				},
			});
		},
	},
};

type Store = ServerState & typeof storeDef;
const {} = store<Store>('project-page', storeDef);
